import { useIntl } from "react-intl";

import type { SearchConditionFilterSet } from "~/client/components/search/SearchConditionFilterSet";
import { descriptionCss } from "~/client/components/search/SearchFilterSetDescription/index.styles";
import { LocationSearchFilterDescription } from "~/client/components/search/SearchFilterSetDescription/Location";
import { describeCondition } from "~/client/components/search/SearchHistory/describeCondition";

const withSeparator = (description: string | JSX.Element, index: number, filterCount: number) => {
  if (filterCount > 1 && index < filterCount - 1) {
    return <>{description}、</>;
  }
  return <>{description}</>;
};

interface Props {
  filterSet: SearchConditionFilterSet;
}
export const SearchFilterSetDescription: React.FC<Props> = ({ filterSet }) => {
  const intl = useIntl();

  const locations = describeCondition
    .location(intl, filterSet.groups, filterSet.folders)
    .map(({ group, folderPath }, i) => (
      <LocationSearchFilterDescription group={group} folderPath={folderPath} key={`location-${i}`} />
    ));

  const filterDescriptions = [
    describeCondition.dateRange(intl, filterSet.dateGte),
    describeCondition.target(intl, filterSet.authorUsers, filterSet.resourceTypes),
    ...locations,
    describeCondition.archive(intl, filterSet.isArchived),
    describeCondition.like(intl, filterSet.isLikedByMe),
    describeCondition.excludeKeywords(intl, filterSet.excludeKeywords),
  ].filter((d) => d !== null);

  return (
    <div>
      {filterDescriptions.map((description, i, all) => (
        <div key={i} css={descriptionCss}>
          {withSeparator(description, i, all.length)}
        </div>
      ))}
    </div>
  );
};
